import { Injectable } from '@angular/core';
import { SBHttpServicesService } from './sbhttp-services.service';
import { AppConfigService } from '../../reactive-forms/services/app-config.service';
import { SharedHandlersService } from '../shared-handlers.service';
import { CustomReturn } from '../../CustomReturn';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {

  breadCrumbs: any[] = [];
  screens: any;

  constructor(private httpService: SBHttpServicesService, private environment: AppConfigService, public Shared: SharedHandlersService, private toastr: ToastrService,
    private jwtHelper: JwtHelperService  ) {

    }

  async GetScreenMetaData(screenid: any, screenParam: any = "") {
    var token = localStorage.getItem("jwt");
    var FWToken = localStorage.getItem("FWToken");
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      var AllToken = this.jwtHelper.decodeToken(token);
    }
    if (AllToken == undefined || AllToken == null) {
      var url = this.environment.apiRoot + 'api/schema/GetScreenAttributes/' + screenid + '/' + (screenParam?.length > 0 ? screenParam : "''");
    }
    else { var url = this.environment.apiRoot + 'api/schema/GetScreenAttributes/' + screenid + '/' + (screenParam?.length > 0 ? screenParam : "''") + '/' + AllToken["role"]; }


    var screenMetaData = await this.httpService.httpGetRequest(url);
    if (screenMetaData && screenMetaData["status"] && screenMetaData["status"] == 2) {
      Swal.fire({
        html: `<div>Error</div><div style=font-size:15px>${screenMetaData["message"]}</div>`,
        showCloseButton: true,
        background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
        showConfirmButton: false
      });
      return;
    }
    return screenMetaData;
  }

  async RemoveScreenMetaData() {
    var url = this.environment.apiRoot + 'api/schema/RemoveMenuScreens/';
    var response = await this.httpService.httpGetRequest(url);
    if (response && response["status"] && response["status"] == 2) {
      Swal.fire({
        html: `<div>Error</div><div style=font-size:15px>${response["message"]}</div>`,
        showCloseButton: true,
        background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
        showConfirmButton: false
      });
      return;
    }
    return response;
  }

    async GetScreenData(ScreenDataSourceid: number, condition: string, pageNumber: number, pageSize: number) {

        var URL = this.environment.apiRoot + 'api/schema/GetScreenData/' + ScreenDataSourceid + '/' + pageNumber + '/' + pageSize + '/' + (!condition ? '' : condition);
        var data = await this.httpService.httpGetRequest(URL);

        if (data["status"] == CustomReturn.Failed) {
          this.Shared.error(data["message"]);
        }
        return data['data'];
    }

    public UpdateBreadCrumbs(screen: any) {

        if (!screen.ParentScreenID) {//entered on page like journey plan or transfer request //no parentscreenid
            this.InitializeBreadCrumbs();
            this.breadCrumbs.push({ name: screen.Text, link: document.getElementsByTagName('base')[0].href +"#/screen/" + screen.ScreenId });
        }
        else if (this.breadCrumbs.length == 0 && screen.ParentScreenID) {//entered on page like customer details or transfer request details from link or refresh //have parentscreenid
            this.InitializeBreadCrumbs();
            this.GetParent(screen);
            this.breadCrumbs.push({ name: screen.Text, link: document.getElementsByTagName('base')[0].href +"#/screen/" + screen.ScreenId });
        }
        else if (this.breadCrumbs.length != 0 && screen.ParentScreenID) {//entered on page like customer details or transfer request details normal way //have parentscreenid
            this.breadCrumbs.push({ name: screen.Text, link: document.getElementsByTagName('base')[0].href +"#/screen/" + screen.ScreenId });
        }
    }

    InitializeBreadCrumbs() {

        this.breadCrumbs = [];
        this.breadCrumbs.push({ name: "Home", link: document.getElementsByTagName('base')[0].href+"#/" });
    }

  async GetParent(screen) {
    if (!this.screens) {
      // var url = this.environment.apiRoot + 'api/schema/getmenuscreens';
      this.screens = this.Shared.MenuItems;
    }
    var haveScreens = this.screens.filter(s => s.Screen.length > 0)[0];
    var parentScreen = haveScreens.Screen.filter(s => s.ScreenId == screen.ParentScreenID)[0];
    if (!parentScreen.ParentScreenID) {
      this.breadCrumbs.push({ name: parentScreen.Text, link: document.getElementsByTagName('base')[0].href + "#/screen/" + parentScreen.ScreenId });//if no parent push for right order
    }
    else {
      this.GetParent(parentScreen);//recursive till no parent
    }
  }
}
